// eslint-disable-next-line import/prefer-default-export

import api from "@/api/api.js";
import tsl from "@/utils/translation.js";

export const appActions = {
    getConstants: async ({ commit }) => {
        return api.getConstants({token: null})
            .then((res) => {
                // Sort Losses by Index before store committing
                res.data['losses'].sort(function compare(a, b) {
                    if (a.index < b.index) return -1;
                    if (a.index > b.index ) return 1;
                    return 0;
                  });

                commit('SET_CONSTANTS', res.data)
            })
    },

    getLangCode: async ({ commit }) => {       
        try {
            const res = await api.getLanguage();
            
            if (res.data?.length > 0) {                
                commit('SET_LANG_CODE', res.data[0]);
            } else {
                commit('SET_LANG_CODE', tsl.getBrowserLocales());
            }
        } catch (error) {
            console.error(error);
            commit('SET_LANG_CODE', tsl.getBrowserLocales());
        }
    }
};

